import { useIntl } from 'react-intl';

import { CalendarUnits } from '@/hooks/purchase/purchase';
import { useDiscountPricing } from '@/hooks/purchase/useDiscountPricing';
import { useDeviceState, usePurchaseParamsState } from '@/hooks/store';

import { FiveStarsContainer, Heading, Stars, StarsText, Subheading } from '../styles';
import messages from './messages';

const FreeTrialCouponHeading = () => {
	const { formatMessage } = useIntl();
	const purchaseParams = usePurchaseParamsState();
	const { isMobile } = useDeviceState();
	const { discountHeading, discountSubheading } = useDiscountPricing();

	function getFreeTrialHeading(): React.ReactNode {
		const message =
			purchaseParams.purchaseType?.units === CalendarUnits.MONTHS
				? messages.trialMonthHeading
				: messages.trialDayHeading;
		return formatMessage(message, {
			amount: purchaseParams?.purchaseType?.duration,
			quantity: purchaseParams.purchaseType?.duration,
			br: isMobile ? <br /> : '',
		});
	}

	return (
		<>
			<Heading>{discountHeading || getFreeTrialHeading()}</Heading>
			<Subheading>{discountSubheading || formatMessage(messages.freeTrialSubheading)}</Subheading>
			<FiveStarsContainer>
				<StarsText>{formatMessage(messages.fiveStars)}</StarsText>
				<Stars />
			</FiveStarsContainer>
		</>
	);
};

export default FreeTrialCouponHeading;
